import { boundAuthTokensHttpUtil, cryptoUtil } from 'core-roblox-utilities';
import UrlConfig from '../../../../../Roblox.CoreScripts.WebApp/Roblox.CoreScripts.WebApp/js/core/http/interfaces/UrlConfig';
import { getTrustedOrigins } from './constants/environment';

export type subdomainRequest =
  | {
      msg: 'checkLoadedRequest';
    }
  | {
      msg: 'signSubdomainRequest';
      identifier: string;
      serializedSubdomainRequestData: string;
    }
  | {
      msg: 'generateSAIRequest';
    };

type subdomainRequestData = {
  url: string;
  requestInit: RequestInit;
};

// eslint-disable-next-line import/prefer-default-export
export async function handleMessage(e: MessageEvent<subdomainRequest>): Promise<void> {
  // Kill events from invalid origin.
  const trustedOrigins = getTrustedOrigins(e.origin);
  if (!trustedOrigins.includes(e.origin)) return;

  const { data } = e;
  if (data.msg === `checkLoadedRequest` && document.readyState === 'complete') {
    window.parent.postMessage(
      {
        msg: 'dataFromHbaFrame',
        data: {
          type: 'loaded'
        }
      },
      e.origin
    );
  }
  if (data.msg === 'signSubdomainRequest') {
    const requestData = JSON.parse(data.serializedSubdomainRequestData) as subdomainRequestData;
    const batConfig: UrlConfig = {
      url: requestData.url,
      method: requestData.requestInit.method,
      withCredentials: requestData.requestInit.credentials === 'include',
      data: requestData.requestInit.body || ''
    };

    try {
      const resultConfig = await boundAuthTokensHttpUtil.buildConfigBoundAuthToken(batConfig);
      // Post the BAT header to the child domain, which will handle updating the
      // headers of the original request.
      window.parent.postMessage(
        {
          msg: 'dataFromHbaFrame',
          data: {
            type: 'batHeader',
            identifier: data.identifier,
            isError: false,
            batHeader: resultConfig.headers
          }
        },
        e.origin
      );
    } catch {
      window.parent.postMessage(
        {
          msg: 'dataFromHbaFrame',
          data: {
            type: 'batHeader',
            identifier: data.identifier,
            isError: true
          }
        },
        e.origin
      );
    }
  }
  if (data.msg === 'generateSAIRequest') {
    const { generateSecureAuthIntent } = cryptoUtil;
    const secureAuthenticationIntent = await generateSecureAuthIntent();
    window.parent.postMessage(
      {
        msg: 'dataFromHbaFrame',
        data: {
          type: 'secureAuthIntent',
          secureAuthIntent: secureAuthenticationIntent
        }
      },
      e.origin
    );
  }
}

window.addEventListener('message', (e: MessageEvent<subdomainRequest>) => {
  // eslint-disable-next-line no-void
  void handleMessage(e);
});

window.addEventListener('load', () => {
  if (window.parent) {
    window.parent.postMessage(
      {
        msg: 'dataFromHbaFrame',
        data: {
          type: 'loaded'
        }
      },
      '*'
    );
  }
});
